import SuperTokens from 'supertokens-web-js';
import Session from 'supertokens-web-js/recipe/session';
/**
 * Must run before any request: the SDK patches `fetch`, so every call to core-api (including the
 * generated client's) carries the session cookies, and an expired session is refreshed through
 * `/auth/session/refresh` and the request retried without our code doing anything.
 */
export function setupSupertokens(params) {
    const { apiDomain } = params;
    SuperTokens.init({
        appInfo: {
            appName: 'Citylytics',
            apiDomain,
            apiBasePath: '/auth',
        },
        recipeList: [Session.init()],
    });
}
